// Playing Videos

let videoSection, videoToPlay, videoPreview;

const stopVideo = (event) => new Promise(resolve => {

  if (!videoSection || !videoToPlay) {
    resolve();
    return false;
  }

  // Handling Keyboard Interaction
  if (event && event.type === 'keydown') {
    const { code } = event;
    const interactionKeyCodes = ['Escape', 'Space'];

    if (!interactionKeyCodes.includes(code)) {
      resolve();
      return false;
    } else {
      if (code === 'Space') {
        event.stopPropagation();
        event.preventDefault();
        videoToPlay.paused ? videoToPlay.play() : videoToPlay.pause();
        resolve();
        return false;
      }
    }
  }

  videoSection.classList.remove('playing-video');
  videoToPlay.pause();
  videoToPlay.currentTime = 0;

  videoToPlay.classList.add('hide');
  videoPreview.classList.remove('hide');

  videoToPlay.parentNode.classList.remove('fullscreen-video');
  videoSection.querySelector('.video-container').prepend(videoToPlay.parentNode);

  const playPromise = videoPreview.play();

  playPromise.then(() => {

    videoToPlay.removeEventListener('ended', stopVideo);
    videoSection = null;
    videoToPlay = null;
    videoPreview = null;

    // Removes Event Listeners
    document.removeEventListener('keydown', stopVideo);

    resolve();

  })
  .catch(err => {
      console.error(err);
  });
});

// Adds Stop function to Stop Video Button
document.getElementById('stop_video_btn').addEventListener('click', stopVideo);

export const autoPlayVideo = sectionId => {
  // Experimentally Toggling Off Autoplay Feature
  return false;

  const autoPlaySection = document.getElementById(sectionId);
  const videoToAutoPlay = autoPlaySection.querySelector('.preview-video');
  const autoPlayPromise = videoToAutoPlay.play();

  autoPlayPromise.then(() => {
    autoPlaySection.classList.add('autoplaying-video');
    if (videoToAutoPlay.muted) {
      if (videoToAutoPlay.currentTime === 0) {
        videoToAutoPlay.currentTime = 0;
      }
      videoToAutoPlay.loop = true;
    }
  })
  .catch(err => {
    console.error(err);
    videoToAutoPlay.pause();
    videoToAutoPlay.currentTime = 1;
  });
};

export const autoStopVideo = sectionId => {
  // Experimentally Toggling Off Autoplay Feature
  return false;

  const autoStopVideoSection = document.getElementById(sectionId);
  const autoStopVideo = autoStopVideoSection.querySelector('.preview-video');
  autoStopVideoSection.classList.remove('autoplaying-video');
  if (autoStopVideo && autoStopVideo.currentTime > 0 && autoStopVideo.muted) {
    autoStopVideo.pause();
    autoStopVideo.currentTime = 1;
  }
};

const playVideo = sectionId => {

  stopVideo().then(() => {
    videoSection = document.getElementById(sectionId);
    videoToPlay  = videoSection.querySelector('.real-video');
    videoPreview = videoSection.querySelector('.preview-video');

    videoPreview.pause();
    videoPreview.currentTime = 0;

    videoPreview.classList.add('hide');
    videoToPlay.classList.remove('hide');

    const placeStopButton = () => {
      const playWordSpacing = (window.innerWidth < 1024) ? 0 : 9;
      const videoBtn = document.getElementById('stop_video_btn');
      const videoHolder = videoToPlay.parentNode;
      videoBtn.style.left = `calc(50% - ${Math.round(videoBtn.offsetWidth / 2)}px)`;
      videoBtn.style.bottom = `calc(50% - ${Math.round((videoBtn.offsetHeight / 2) - playWordSpacing)}px)`;
      videoHolder.appendChild(videoBtn);
    };

    setTimeout(() => {

      const playPromise = videoToPlay.play();

      videoToPlay.currentTime = 0;
      videoToPlay.loop = false;

      playPromise.then(() => {

        // Go Fullscreen on Mobile
        // if (window.innerWidth < 1024) {
        //   videoToPlay.parentNode.classList.add('fullscreen-video');
        //   document.body.appendChild(videoToPlay.parentNode);
        // }

        videoToPlay.muted = false;
        videoSection.classList.toggle('playing-video');

        placeStopButton();

        // Adds Event Listeners
        document.addEventListener('keydown', stopVideo);
        videoToPlay.addEventListener('ended', stopVideo);

      })
      .catch(err => {
        console.error(err);
      });

    }, 300);

  })
  .catch(err => {
      console.error(err);
  });
};

global.playVideo = playVideo;


// Mobile Vanilla Intersection Observers for Autoplay/Autostop

if (window.innerWidth < 1024) {

  // Scrolling Observers

  const sections = ['section_2', 'section_3', 'section_4', 'section_6', 'section_7'];

  const optionsGenerator = observerId => ({
    root: document.querySelector(observerId),
    rootMargin: '0px',
    threshold: 0.5
  });

  const sectionObservers = {};
  const scrollObserveCallback = entries => {
    const [ entry ] = entries;
    const { isIntersecting, target } = entry;
    if (isIntersecting) {
      setTimeout(() => {
        autoPlayVideo(target.id);
      }, 1000);
    } else {
      setTimeout(() => {
        autoStopVideo(target.id);
      }, 500);
    }
  };

  sections.forEach(section => {
    sectionObservers[section] = new IntersectionObserver(scrollObserveCallback, optionsGenerator(section));
    sectionObservers[section].observe(document.getElementById(section));
  });

}